import { ReactElement, useEffect } from 'react';

import { LocalStackEventType, LocalStackWebEvent, WINDOW_EVENT } from '../constants';

import { eventSystem } from './Observable';
import { ResizerHandler } from './ResizerHandler';
import { isOriginAllowed } from './utils';

interface Props {
  children: ReactElement;
}

export const CommunicationProvider = ({ children }: Props): ReactElement => {
  const messageEventHandler = (event: MessageEvent<LocalStackWebEvent>) => {
    if (!isOriginAllowed(event.origin)) {
      return;
    }

    if (Object.values(LocalStackEventType).includes(event.data.eventType)) {
      eventSystem.notify(event.data);
    }
  };

  useEffect(() => {
    window.addEventListener(WINDOW_EVENT, messageEventHandler);

    return () => {
      window.removeEventListener(WINDOW_EVENT, messageEventHandler);
    };
  }, []);

  return <ResizerHandler>{children}</ResizerHandler>;
};
